import React, { useEffect, useState } from "react";
import CancelButton from "../Button/CancelButton";
import SaveButton from "../Button/SaveButton";
import { useTranslation } from "react-i18next";

export const GLOBAL_EXPENSE_FILTER_KEY = "global_expense_table_filters";

export function getGlobalExpenseFilters() {
  try {
    const saved = localStorage.getItem(GLOBAL_EXPENSE_FILTER_KEY);
    if (saved) return JSON.parse(saved);
  } catch {}
  return {
    salesTransportation: true,
    salesLoading: true,
    purchaseTransportation: true,
    purchaseLoading: true,
  };
}

export default function TableFilterModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  const [filters, setFilters] = useState(getGlobalExpenseFilters);

  useEffect(() => {
    if (isOpen) {
      setFilters(getGlobalExpenseFilters());
    }
  }, [isOpen]);

  const handleToggle = (key) => {
    setFilters((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = () => {
    localStorage.setItem(GLOBAL_EXPENSE_FILTER_KEY, JSON.stringify(filters));
    window.dispatchEvent(new Event("global_expense_filters_updated"));
    onClose();
  };

  if (!isOpen) return null;

  const options = [
    { key: "salesTransportation", label: t("sales") + " - " + t("transportationExpense") },
    { key: "salesLoading",        label: t("sales") + " - " + t("loading/UnloadingExpense") },
    { key: "purchaseTransportation", label: t("purchase") + " - " + t("transportationExpense") },
    { key: "purchaseLoading",     label: t("purchase") + " - " + t("loading/UnloadingExpense") },
  ];

  return (
    <div className="fixed inset-0 bg-black/15 bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white py-2 px-2 rounded shadow-lg max-w-xl">
        <div className="font-semibold bg-theme-headerBg rounded-1 px-4 py-[2px] text-theme-color mb-2">
          {t("tableFilterSettings")}
        </div>

        <div className="px-2 py-2 flex flex-col gap-2">
          {options.map(({ key, label }) => (
            <label key={key} className="flex items-center gap-2">
              <input
                type="checkbox"
                className="accent-theme-headerBg"
                checked={filters[key]}
                onChange={() => handleToggle(key)}
              />
              <span className="text-sm">{label}</span>
            </label>
          ))}
        </div>

        <div className="flex justify-end gap-3 mt-2">
          <CancelButton onClick={onClose} text={t("cancel")} />
          <SaveButton onClick={handleSave} text={t("save")} />
        </div>
      </div>
    </div>
  );
}